export var Step;
(function (Step) {
    Step["Program"] = "PROGRAM";
    Step["Format"] = "FORMAT";
    Step["Info"] = "INFO";
    Step["Print"] = "PRINT";
    Step["Preview"] = "PREVIEW";
    Step["Download"] = "DOWNLOAD";
})(Step || (Step = {}));
export var DateFormatType;
(function (DateFormatType) {
    DateFormatType["Date"] = "DATE";
    DateFormatType["Year"] = "YEAR";
})(DateFormatType || (DateFormatType = {}));
